<template>
  <div>
    <b-form @submit.prevent="startSearch()">
      <b-input-group class="mt-3 w-100">
        <b-form-input v-model="location" list="my-list-id"></b-form-input>
        <datalist id="my-list-id">
          <option v-for="(result, i) in searchResults" :key="i">{{ result }}</option>
        </datalist>
        <b-input-group-append>
        <b-button variant="dark" type="submit" :disabled="!location" ><font-awesome-icon style="font-size: 15px;" :icon="['fas', 'search']"/></b-button>
        </b-input-group-append>
      </b-input-group>
    </b-form>
    <b-row class="m-0 justify-content-center" >
      <small v-if="!location" class="mt-2 text-center text-danger">Gebe Deinen Ort ein und wähle einen Eintrag aus der Liste aus</small>
    </b-row>
  </div>
</template>

<script>
import axios from 'axios'

export default {
  name: 'GooglePlacesAutocomplete',

  props: {

  },
  components: {

  },
  data: () => {
    return {
      location: '',
      searchResults: [],
      service: null,
    }
  },
  // metaInfo () {
  //   return {
  //     script: [{
  //       src: `https://maps.googleapis.com/maps/api/js?key=AIzaSyD_9KM0IcRD81nQUVZKNFVW_d5NEJU3SIM&libraries=places&region=de`,
  //       async: true,
  //       defer: true,
  //       callback: () => this.MapsInit() // will declare it in methods
  //     }]
  //   }
  // },
  watch: {
    location (newValue) {
      if (newValue && this.service) {
        this.service.getPlacePredictions({
          input: this.location,
          types: ['(cities)']
        }, this.displaySuggestions)
      }
    }
  },
  computed: {
   adressData(){
     return this.$store.getters.adressData
   }
  },
  mounted(){
    this.$store.commit('adressData', JSON.parse(localStorage.getItem('adressData')))
    if(this.adressData){
      this.location = this.adressData.locality
    }
    this.MapsInit()
  },
  beforeDestroy(){

  },
  methods: {
    startSearch(){
      if(!this.location) return
      this.getLocation()
    },
    MapsInit () {
      this.service = new window.google.maps.places.AutocompleteService()
    },
    displaySuggestions (predictions, status) {
      if (status !== window.google.maps.places.PlacesServiceStatus.OK) {
        this.searchResults = []
        return
      }
      this.searchResults = predictions.map(prediction => prediction.description) 
    },
    getLocation(){
      if(!this.location) return
      axios.get('https://maps.googleapis.com/maps/api/geocode/json?address=germany,' + this.location + '&region=de&key=AIzaSyD_9KM0IcRD81nQUVZKNFVW_d5NEJU3SIM')
            .then(
              (res) => {

                  var adressData = {
                    country: "Deutschland",
                    latitude: res.data.results[0].geometry.location.lat,
                    locality: res.data.results[0].formatted_address,
                    longitude: res.data.results[0].geometry.location.lng,
                  }
                  this.$store.dispatch('getCompany')
                  this.$store.commit('adressData', adressData)

                  localStorage.setItem('adressData', JSON.stringify(this.adressData))
                  this.$router.push('/restaurants?locality='+this.location).catch(() => {})
                  // if(this.$route.name == 'Restaurants'){
                  //   this.$router.push('/restaurants?locality='+this.location).catch(() => {})
                  //   window.location.reload()
                  // }else{
                  //   this.$router.push('/restaurants?locality='+this.location).catch(() => {})
                  // }
                  
              }
            )
            .catch(
              error => {
                  console.log(error)
            }
          )
    },
    
  }
}
</script>